import cartOptions from '../cart/cart-slide';

// LEVEL 1
//toggle nav
$('.navbar-toggler').on('click', function () {
  //if main header is open
  if ($('.menu-open').length) {
    //console.log('click');
    $('.dropper').removeClass('active');
    $('.level-2').removeClass('drop-open');
    $('.drop-menu').removeClass('active');
    $('.main-header').removeClass('menu-open');
    $('.coto_header').removeClass('mobile-squish');
    //otherwise open it up
  } else {
    $('.main-header').addClass('menu-open');
    $('.coto_header').addClass('mobile-squish');
  }
});

// LEVEL 2
//dropdown
$('.dropper').on('click', function () {
  var thisDrop = $(this).attr('attr-drop');
  //console.log(thisDrop);
  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $('.level-2').removeClass('drop-open');
    $('.drop-menu').removeClass('active');
    $('.main-header').removeClass('menu-open');
  } else {
    $('.drop-menu').removeClass('active');
    $('.dropper').removeClass('active');
    $(this).addClass('active');
    $('#' + thisDrop).addClass('active');
    $('.level-2').addClass('drop-open');
    $('.main-header').addClass('menu-open');
  }
});
//mobile back button
$('.drop-back').on('click', function () {
  $('.dropper').removeClass('active');
  $('.level-2').removeClass('drop-open');
  $('.drop-menu').removeClass('active');
  $('.sub').removeClass('active');
});

// LEVEL 3
$('.sub .title span').on('click', function () {
  var thisSub = $(this).attr('attr-sub');
  //console.log(thisSub);
  if ($('#' + thisSub).hasClass('active')) {
    $('#' + thisSub).removeClass('active');
  } else {
    $('.sub').removeClass('active');
    $('#' + thisSub).addClass('active');
  }
});

//Search Toggle
$('.search-toggler').on('click', function () {
  $('.nav-search').addClass('search-open');
});

// mobile search icon toggle
$('.open-search').on('click touchstart', function () {
  $('#Search-new-header').focus();
});

// Location Drop Down
$('#flag_toggleh').on('click touchstart', function () {
  //$("#toggle_flgh").toggle();
  if ($('#toggle_flgh').hasClass('open')) {
    $('#toggle_flgh').removeClass('open');
  } else {
    $('#toggle_flgh').removeClass('open');
    $('#toggle_flgh').addClass('open');
  }
  return false;
});

// Open and Close Side Cart
$('.cart').on('click', function (e) {
  e.stopPropagation();
  $('.dropper').removeClass('active');
  $('.level-2').removeClass('drop-open');
  $('.drop-menu').removeClass('active');
  $('.main-header').removeClass('menu-open');
  $('.coto_header').addClass('cart-squish');
  cartOptions.openCart();
});
// Open and Close Side Cart
$('.cart-close').on('click', function (e) {
  e.stopPropagation();
  $('.coto_header').removeClass('cart-squish');
  cartOptions.closeCart();
});

// when an element outside is clicked
// $(document).on('click', function (e) {
//   if (!$(e.target).closest('.nav-search').length) {
//     $('.nav-search').removeClass('search-open');
//   }
//   if (!$(e.target).closest('.cart-wrapper').length) {
//     cartOptions.closeCart();
//   }
//   if (!$(e.target).closest('.main-header').length) {
//     $('.dropper').removeClass('active');
//     $('.level-2').removeClass('drop-open');
//     $('.drop-menu').removeClass('active');
//     $('.main-header').removeClass('menu-open');
//   }
// });

$('.mobile-search').on('submit', function () {
  $('.dropper').removeClass('active');
  $('.level-2').removeClass('drop-open');
  $('.drop-menu').removeClass('active');
  $('.main-header').removeClass('menu-open');
});

var headerScroll = function () {
  let scrollPosition = window.pageYOffset;
  if (scrollPosition >= 80) {
    $('.coto_header').addClass('squish');
  } else {
    $('.coto_header').removeClass('squish');
  }
};

// var $mainBanner = document.querySelector('.main-banner'),
// 	$mainHeader = document.querySelector('.main-header'),
//     headerScroll = function() {
//
// 	let bannerHeight = $mainBanner.offsetHeight,
// 		headerHeight = $mainHeader.offsetHeight,
// 		scrollPosition = window.pageYOffset,
// 		isFixed = $mainHeader.classList.contains('fixed');
//
// 	if (scrollPosition >= bannerHeight) {
// 		if (!isFixed) {
// 			$mainBanner.classList.add('fixed');
// 			$mainHeader.classList.add('fixed');
// 			//document.querySelector('.main-content').style.paddingTop = `${headerHeight}px`;
// 		}
// 	} else {
// 		if (isFixed) {
// 			$mainBanner.classList.remove('fixed');
// 			$mainHeader.classList.remove('fixed');
// 			//document.querySelector('.main-content').removeAttribute('style');
// 		}
// 	}
// };

// Event Listeners for Header Scroll
window.addEventListener('load', function () {
  headerScroll();
});

window.addEventListener('scroll', function () {
  headerScroll();
});

// reload after width resize
const origWidth = window.innerWidth;
let newWidth;
//console.log(origWidth);
window.addEventListener('resize', function () {
  setTimeout(function () {
    newWidth = window.innerWidth;
    //console.log(newWidth);
    if (newWidth <= 1200) {
      if (newWidth != origWidth) {
        $('.dropper').removeClass('active');
        $('.level-2').removeClass('drop-open');
        $('.drop-menu').removeClass('active');
        $('.main-header').removeClass('menu-open');
      }
    }
  }, 500);
});
